import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';

import Button from '../Button';

interface CloseProps {
  className?: string;
  onClick: () => void;
}

const Close: FC<CloseProps> = ({ className, onClick }) => (
  <Button className={className} onClick={onClick}>
    <FontAwesomeIcon icon={faXmark} />
  </Button>
);

export default Close;
